import { Translate } from '@chipinside/translate'
import { Chip, ChipProps } from '@mui/material'
import { Circle } from 'lucide-react'

export type IntegrationStatus = 'active' | 'available'

interface TypeIntegrationStatusProps {
  value: IntegrationStatus
  size?: ChipProps['size']
}

const STATUS_CHIP: Record<IntegrationStatus, { color: 'primary' | 'secondary'; label: string }> = {
  active: { color: 'primary', label: 'active_female_singular' },
  available: { color: 'secondary', label: 'available_singular' },
}

export function TypeIntegrationStatus({ size = 'small', value }: TypeIntegrationStatusProps) {
  const statusChip = STATUS_CHIP[value]

  if (!statusChip) return '-'

  return (
    <Chip
      icon={<Circle size={8} fill="currentColor" />}
      color={statusChip.color}
      label={Translate({ messageKey: statusChip.label })}
      size={size}
      variant="soft"
      sx={{ pl: 0.5 }}
    />
  )
}
